__turbopack_context__.v({
  "fadeIn": "GlobeLoadingScreen-module__gBod4G__fadeIn",
  "loadingContainer": "GlobeLoadingScreen-module__gBod4G__loadingContainer",
  "loadingText": "GlobeLoadingScreen-module__gBod4G__loadingText",
  "logoContainer": "GlobeLoadingScreen-module__gBod4G__logoContainer",
  "pulse": "GlobeLoadingScreen-module__gBod4G__pulse",
});
